import {Component, Input} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {User} from "../../user/user";
import {AuthService} from "../../auth/auth.service";
import {DbResponse} from "../../shared/interceptors/db-response";
import {ResetPasswordSuccessComponent} from "../reset-password-success/reset-password-success.component";
import {filter, first} from "rxjs/operators";


@Component({
    selector: 'db-reset-password',
    templateUrl: 'settings-reset-password.component.html',
    styleUrls: ['settings-reset-password.component.scss'],
    standalone: false
})
export class SettingsResetPasswordComponent extends DialogComponent<null, boolean> {
  public cancelForm: FormGroup;
  public loading: boolean;
  @Input() user: User;


  constructor(
    private _authService: AuthService,
    private _dialogService: DialogService,
  ) {
    super(
      _dialogService
    );

    this.cancelForm = new FormGroup({
      'cancelation': new FormControl('', [Validators.required])
    });

  }

  public submitReset(): void {
    this.loading = true;
    this._authService.sendResetPasswordMail(this.user.email)
      .pipe(filter((response: DbResponse): boolean => !!response),
      first())
      .subscribe((response: DbResponse): void => {
        this.close();
        this.loading = false;
        if (response.success) {
          this._dialogService.addDialog(ResetPasswordSuccessComponent);
        }
      });
  }


}
